import React, {useState} from 'react';
import CardHeader from './CardHeader';
import { ApiHost } from '../../utils/ApiConfig';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import { revokeApplication } from '../../services/Application';
import ConfirmPopup from './ConfirmPopup';


import logger from "../../utils/logger";
const CertificateDetails = ({ applicationData, displayMode = "Client", onShippingInfoUpdate }) => {
    const pickupStatuses = [14, 15, 18];
    const certificateReadyToDownloadStatuses = [14, 15, 16, 17, 18];
    const courierStatuses = [13, 14, 16, 17, 18, 19];
    const trackingStatuses = [16, 17, 18, 19];
    const trackingInputStatuses = [16, 17, 18];
    const { accessToken } = useAuth();

    const [trackingInputSwitch, setTrackingInputSwitch] = useState(false);
    const [shippingInfo, setShippingInfo] = useState(applicationData.shippingInfo);
    const [loading, setLoading] = useState(false);
    const [printing, setPrinting] = useState(false);
    const [showWarning, setShowWarning] = useState(false);

    const ShippingInfoEnter = (e) => {
        setShippingInfo(e.target.value);
    };

    const formatDate = (dateString) => {
        try {
            const [year, month, day] = dateString.split('-');
            if (!year || !month || !day) throw new Error("Invalid date format: " + dateString);
            return `${day}.${month}.${year} r.`;
        } catch (error) {
            logger.error("Error formatting date:", error);
            return "-";
        }
    };

    const extractTrackingNumber = (trackingInfo) => {
        try {
            if (!trackingInfo.includes("furgonetka.pl"))
                return trackingInfo;
            const trackingNumber = trackingInfo.split('/')[4]; 
            return trackingNumber;
        } catch (error) {
            logger.error("Error extracting tracking number:", error);
            return "-";
        }
    }

    const downloadFile = async (print = false, copy = false) => {
        try {
            if (!applicationData.id)
                throw "Brak identyfikatora wniosku";
               
            let url = ApiHost + '/certificate/' + (print ? "print" : "original") + '/' + applicationData.id;
            if (print){
                setPrinting(true);
                url += copy ? '/true' : '/false';
            }
            else
                setLoading(true);
            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (!response.ok) {
                throw new Error('Błąd podczas pobierania pliku');
            }
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = `${applicationData.certificateNumber}_Certificate_of_Origin_Poland${print ? '_Print' : ''}${copy ? '_Copy' : ''}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();

        } catch (error) {
            logger.error('Błąd podczas pobierania pliku:', error);
            throw error;
        } finally {
            if (print)
                setPrinting(false);
            else
                setLoading(false);
        }
    };

    const onRevokeApplication = async () => {
        try {
            if (!applicationData.id)
                throw "Brak identyfikatora wniosku";

            const response = await revokeApplication(applicationData.id, accessToken);
            if (response === true) {
                window.location.reload();
            } else {
                alert("Błąd podczas wycofywania wniosku: " + response.data.message);
            }
        } catch (error) {
            logger.error('Błąd podczas wycofywania wniosku:', error);
            alert("Błąd podczas wycofywania wniosku: " + error.message);
        }
    }

    return (
        <div>
            <CardHeader text="Szczegóły świadectwa" onlyText="true" />
            <div className='card container-fluid shadow ms-4 px-4 py-3 w55'>
                <div className='d-flex flex-column w47'>
                    <div className='d-flex flex-row'>
                        <div>
                            <i className='bi bi-file-earmark-fill text-black-50 fs-1'></i>
                        </div>
                        <div className='ms-1'>
                            <strong>Świadectwo {applicationData.certificateNumber}</strong><br />
                            {certificateReadyToDownloadStatuses.includes(applicationData.status) && (
                                <span className='text-black-50'>Świadectwo można zweryfikować na stronie internetowej <a href="https://co.kig.pl/verify" target='blank'>co.kig.pl</a></span>
                            )}
                        </div>
                        {certificateReadyToDownloadStatuses.includes(applicationData.status) && (
                            <div className='ms-auto'>
                                <div className='d-flex flex-column'>
                                    {loading ? (
                                        <div className='btn btn-primary ms-auto w11 h2'>
                                            <LoadingSpinner text='Pobieranie' />
                                        </div>
                                    ) : (
                                        <button className='btn btn-primary ms-auto w11 h2' onClick={() => downloadFile()}>Pobierz</button>
                                    )}

                                    {displayMode === "Operator" && (
                                        printing ? (
                                        <div className='btn btn-outline-primary mt-1 ms-auto w11 h2'>
                                            <LoadingSpinner text='Drukowanie' />
                                        </div>
                                    ) : (
                                        <button className='btn btn-outline-primary mt-1 w11 h2' onClick={() => downloadFile(true)}>Wydruk</button>
                                    ))}

                                    {displayMode === "Operator" && (
                                        printing ? (
                                        <div className='btn btn-outline-primary mt-1 ms-auto w11 h2'>
                                            <LoadingSpinner text='Drukowanie' />
                                        </div>
                                    ) : (
                                        <button className='btn btn-outline-primary mt-1 w11 h2' onClick={() => downloadFile(true, true)}>Wydruk kopii</button>
                                    ))}

                                    {displayMode === "Operator" && (
                                        <button className='btn btn-danger mt-1 w11 h2' onClick={() => setShowWarning(true)}>Wycofaj</button>
                                    )}
                                </div>
                                <ConfirmPopup
                                    show={showWarning}
                                    title="Uwaga"
                                    text="Czy na pewno chcesz wycofać świadectwo?"
                                    confirmText="Tak"
                                    cancelText="Nie"
                                    onConfirm={() => { setShowWarning(false); onRevokeApplication(); }}
                                    onCancel={() => setShowWarning(false)}
                                />
                                
                            </div>
                        )}
                    </div>

                    {applicationData.paymentShipping === "pickup" && pickupStatuses.includes(applicationData.status) && (
                        <div className='border-top pt-1 mt-1 d-flex flex-column'>
                            <div className='w-100 d-flex flex-row align-items-center'>
                                <div>
                                    <div className='rounded-circle bg-warning d-flex justify-content-center align-items-center' style={{ width: '30px', height: '30px' }}>
                                        <i className='bi bi-truck text-white'></i>
                                    </div>
                                </div>

                                <div className='ms-1'>
                                    <strong>Forma dostawy - odbiór osobisty</strong><br />
                                    {applicationData.status === 18 && (
                                        <span className='text-black-50'>Świadectwo zostało odebrane</span>
                                        )}
                                </div>
                            </div>

                            {applicationData.status !== 18 && (
                                <div className='mt-1'>
                                    Świadectwo jest gotowe do odbioru w:<br />
                                    <div className='ms-1 my-1'>
                                        KIG - Biuro BLCA - Zespół Świadectw Pochodzenia<br />
                                        ul. Trębacka 4, pok. 04 parter<br />
                                        00-074 Warszawa<br />
                                        tel. 22 630 96 17 | 22 630 97 03 | 22 630 96 79 | 22 630 99 07
                                    </div>
                                    Zapraszamy po odbiór od poniedziałku do piątku w godzinach 9:00 - 15:00.<br/>
                                    Jeżeli wysyłasz własnego kuriera po odbiór, wyślij nam etykietę kurierską na adres&nbsp;<a href='mailto:swiadectwapochodzenia@kig.pl'>swiadectwapochodzenia@kig.pl</a> abyśmy mogli umieścić ją na kopercie.
                                </div>
                            )}
                        </div>
                    )}

                    {applicationData.paymentShipping === "courier" && courierStatuses.includes(applicationData.status) && (
                        <div className='border-top pt-1 mt-1 d-flex flex-column'>
                            <div className='w-100 d-flex flex-row align-items-center'>
                                <div>
                                    <div className={'rounded-circle ' + (applicationData.status === 16 ? 'bg-warning' : 'bg-success') + ' d-flex justify-content-center align-items-center'} style={{ width: '30px', height: '30px' }}>
                                        <i className='bi bi-truck text-white'></i>
                                    </div>
                                </div>

                                <div className='ms-1'>
                                    <strong>Forma dostawy - wysyłka</strong><br />
                                    {applicationData.status === 16 ? (
                                        <span className='text-black-50'>Oczekuje na wysyłkę</span>
                                    ) : (
                                    trackingStatuses.includes(applicationData.status) && (
                                        <span className='text-black-50'>Nadano: {formatDate(applicationData.shippingDateSent)}</span>
                                    ))}
                                </div>
                            </div>

                            <div className='mt-1'>
                                Świadectwo zostanie dostarczone na adres:<br />
                                <div className='ms-1 mt-1'>
                                    {applicationData.paymentShippingAddress.name}<br />
                                    {applicationData.paymentShippingAddress.street} {applicationData.paymentShippingAddress.building} {applicationData.paymentShippingAddress.appartment ? "/ " + applicationData.paymentShippingAddress.appartment : ""}<br />
                                    {applicationData.paymentShippingAddress.postCode} {applicationData.paymentShippingAddress.city} ({applicationData.paymentShippingAddress.country})<br />
                                    tel. {applicationData.paymentShippingAddress.phoneNumber}
                                </div>
                            </div>

                            {trackingStatuses.includes(applicationData.status) && (!trackingInputSwitch) && (
                                <div className='d-flex flex-row mt-1'>
                                    <div className='w7'>
                                        <strong>Numer przesyłki</strong>
                                    </div>
                                        <div className='w15 ms-1'>
                                        {shippingInfo.startsWith("https://") ? (
                                            <span><a href={shippingInfo} target='_blank'>{extractTrackingNumber(shippingInfo)}</a></span>
                                        ) : (
                                            <span>{shippingInfo}</span>
                                        )}
                                        </div>
                                        {(["Operator", "Shipping"].includes(displayMode)) && (trackingInputStatuses.includes(applicationData.status)) && (
                                            <div className='ms-1'>
                                                <button className='btn btn-outline-primary w7 h2' onClick={() => setTrackingInputSwitch(!trackingInputSwitch)}>Zmień</button>
                                            </div>
                                        )}
                                </div>
                            )}
                            {trackingInputStatuses.includes(applicationData.status) && (trackingInputSwitch) && (
                                <div className='d-flex flex-row mt-1'>
                                    <div className='w7'>
                                        <strong>Śledzenie (link)</strong>
                                    </div>
                                    <div className='w15 ms-1'>
                                        <input
                                            type='text'
                                            className='form-control'
                                            value={shippingInfo === 'Brak informacji o przesyłce' ? '' : shippingInfo}
                                            onChange={ShippingInfoEnter}
                                            placeholder='Wprowadź dane do śledzenia przesyłki'
                                        />
                                    </div>
                                    <div className='ms-1'>
                                        <button
                                            className='btn btn-outline-primary w7 h2'
                                            onClick={() => {onShippingInfoUpdate(shippingInfo); setTrackingInputSwitch(!trackingInputSwitch)}}
                                        >
                                            Zapisz
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CertificateDetails;

